import { Location as NgLocation } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { CwMenu, CwMenuItem } from '@bbraun/cortex-angular';
import { TranslocoDirective } from '@jsverse/transloco';

import { ROUTES } from '../../definitions/constants/routes.constants';
import { RouterStoreFacade } from '../../stores/global-store/router/router-store.facade';

@Component({
  selector: 'app-header-app-switch',
  imports: [
    MatIcon,
    MatIconButton,
    TranslocoDirective,
    CwMenu,
    CwMenuItem,
    MatTooltip
  ],
  templateUrl: './header-app-switch.component.html',
  styleUrl: './header-app-switch.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class HeaderAppSwitchComponent {
  private readonly window = window;
  public readonly routerFacade = inject(RouterStoreFacade);
  private readonly ngLocation = inject(NgLocation);

  protected readonly ROUTES = ROUTES;

  public menuOpen = false;

  public onAppSelected(route: string): void {
    this.ngLocation.go(route);
    this.window.location.reload();
  }

  public onMenuToggle(): void {
    this.menuOpen = !this.menuOpen;
  }
}
